import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/arrow.png'
import _imports_1 from '../assets/img/hand.png'
import _imports_2 from '../assets/img/wheel.png'
import _imports_3 from '../assets/img/skip_btn.png'
import _imports_4 from '../assets/img/confirm_btn.png'


const _hoisted_1 = {
  key: 0,
  class: "guide-wrapper"
}
const _hoisted_2 = { class: "guide-inner" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"tips\"><div class=\"up-down tip\"><div class=\"img\"><div class=\"arrow\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"hand\"><img src=\"" + _imports_1 + "\" alt=\"\"></div></div><p>上下移动屏幕，调整视角高度</p></div><div class=\"wheel\"><img src=\"" + _imports_2 + "\" alt=\"\"></div><div class=\"left-right tip\"><div class=\"img\"><div class=\"arrow\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"hand\"><img src=\"" + _imports_1 + "\" alt=\"\"></div></div><p>左右旋转视角，四处看看</p></div></div>", 1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "skip-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, _hoisted_5),
          _createElementVNode("div", {
            class: "confirm-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, _hoisted_7)
        ])
      ]))
    : _createCommentVNode("", true)
}